import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { formatCurrency } from "@tudigo-monorepo/core-tudigo-utils";
import {
  ComparatorSelectionList,
  ComparatorTable,
  ComparatorTableContent,
  ComparatorTableRow,
  ComparatorTableRowLabel,
  ComparatorTableRowValue,
  ComparatorTableTooltip,
  ComparatorTableTrigger,
} from "@tudigo-monorepo/web-tudigo-comparator";

export function ProjectsComparatorActivityTable() {
  return (
    <ComparatorTable defaultOpen>
      <ComparatorTableTrigger>Activité</ComparatorTableTrigger>
      <ComparatorTableContent>
        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            CA {new Date().getFullYear() - 1}
            <ComparatorTableTooltip>
              CA : chiffre d&apos;affaires en €
            </ComparatorTableTooltip>
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-1/2">
                {project.information?.revenueLastYearInCents
                  ? formatCurrency(project.information.revenueLastYearInCents)
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            Prévision CA {new Date().getFullYear()}
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-2/3">
                {project.information?.revenueForecastForCurrentYearInCents
                  ? formatCurrency(
                      project.information.revenueForecastForCurrentYearInCents,
                    )
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            EBE Run Rate
            <ComparatorTableTooltip>
              Estimation de l&apos;Excédent Brut d&apos;Exploitation annuel (EBE
              : indicateur financier qui mesure la rentabilité d&apos;une
              entreprise)
            </ComparatorTableTooltip>
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-1/2">
                {project.information?.ebitdaRunRateInCents
                  ? formatCurrency(project.information.ebitdaRunRateInCents)
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>

        <ComparatorTableRow>
          <ComparatorTableRowLabel>
            Prévision EBE {new Date().getFullYear()}
          </ComparatorTableRowLabel>
          <ComparatorSelectionList>
            {(project: Project) => (
              <ComparatorTableRowValue loaderClassName="w-2/3">
                {project.information?.ebitdaForecastForCurrentYearInCents
                  ? formatCurrency(
                      project.information.ebitdaForecastForCurrentYearInCents,
                    )
                  : "N/A"}
              </ComparatorTableRowValue>
            )}
          </ComparatorSelectionList>
        </ComparatorTableRow>
      </ComparatorTableContent>
    </ComparatorTable>
  );
}
